import UiCustomization, { defaultUiCustomization } from "domain/uiCustomization";
import merchantService from "./merchantService";
import { useEffect, useState } from "react";

let cachedUiCustomization: UiCustomization;

export default function useUiCustomization(): UiCustomization {
    const [uiCustomization, setUiCustomization] = useState<UiCustomization>(cachedUiCustomization ?? defaultUiCustomization);

    useEffect(() => {
        if (cachedUiCustomization)
            return;

        merchantService.getErpIntegration()
            .then(e => {
                cachedUiCustomization = e?.erpConfiguration?.uiCustomization ?? defaultUiCustomization;
                setUiCustomization(cachedUiCustomization);
            });
    }, []);

    return uiCustomization;
}